/* eslint-disable array-callback-return */
import React from 'react';
import {OverlayOption} from './LayerInfo/OverLayLayer';
import {LidarOption} from './LayerInfo/LidarLayer';
import {ModelSetOption} from './LayerInfo/ModelSetLayer';
import {Acute3DOption} from './LayerInfo/Acute3DLayer';
import {PipelineOption} from './LayerInfo/PipelineLayer';
import {ModelOption} from './LayerInfo/ModelLayer';
import {ProjectorOption} from './LayerInfo/ProjectorLayer';
import {I3SOption} from './LayerInfo/I3SLayer';
import {ThreeDTilesOption} from './LayerInfo/3DTilesLayer';

class TerrainSiderBar extends React.Component{
    constructor() {
        super();
        this.sidebarChange = this.sidebarChange.bind(this);
        this.state = {
            siderValue:100,
            intervalID:null
        };
    }    
    componentDidMount(){
        let siderValue = 100;
        let componentThis = this;
        var intervalID = setInterval(function() {
            siderValue = window.main.OView.terrainAlpha * 100;            
            componentThis.setState({siderValue:siderValue});
        }, 1000);        
        this.setState({intervalID:intervalID});
    }
    sidebarChange(event){        
        window.main.OView.terrainAlpha = event.target.value/100;
        this.setState({siderValue:event.target.value});
    }
    render(){
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <h4 className="ts eight wide column">地形透視</h4>
                    <label className="ts eight wide column right aligned">{this.state.siderValue + "%"}</label>
                </div>
                
                <div>                    
                    <input type="range" min="0" max="100" value={this.state.siderValue} step="1" onChange={(e)=>this.sidebarChange(e)} style={siderRangeCSS}></input>
                </div>
            </div>
        );
    }
}

class LayerOptionSidebar extends React.Component{
    constructor() {
        super();
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
        this.deleteLayerList = this.deleteLayerList.bind(this);
    }
    sidebarSwitch(){
        this.props.setlayerOptionOpen();
    }
    deleteLayerList(layer){
        this.props.deleteLayerList(layer);
    }
    render(){
        const islayerOptionOpen = this.props.islayerOptionOpen;        
        const LayerList_2D = this.props.LayerList.Layer_2D;
        const LayerList_3D = this.props.LayerList.Layer_3D;
        const Layer2DLength = (this.props.LayerList.Layer_2D).length;
        const Layer3DLength = (this.props.LayerList.Layer_3D).length;
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : islayerOptionOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const titleCSS = {
            margin: '10px 10px 10px 10px' 
        };
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="fourteen wide column">
                                <h4 className="ts header" style={titleCSS}>
                                    <i className="options icon"></i>
                                    <div className="content">
                                        圖層設定
                                    </div>
                                </h4>
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>
                    <div id="detailsList">
                        <TerrainSiderBar />
                        <details className="ts accordion item">
                            <summary>
                                <i className="dropdown icon"></i>
                                2D圖層
                                {
                                    Layer2DLength === 0 ? null:
                                    <div id="tag" class="ts floating horizontal circular positive label" style={{top: '1px'}}>{Layer2DLength}</div>
                                }
                            </summary>                            
                            {
                                LayerList_2D.map(
                                    (layer)=>
                                        <OverlayOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>
                                )
                            }                             
                        </details>
                        <details className="ts accordion item">
                            <summary>
                                <i className="dropdown icon"></i>
                                3D圖層
                                {
                                    Layer3DLength === 0 ? null:
                                    <div id="tag" class="ts floating horizontal circular positive label" style={{top: '1px'}}>{Layer3DLength}</div>
                                }
                            </summary>  
                            {
                                LayerList_3D.map(
                                    (layer)=>
                                    {
                                        switch(layer.layerType){
                                            case "Lidar" :
                                                return <LidarOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "ModelSet":
                                                return <ModelSetOption layer={layer} LayerList_2D={LayerList_2D} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "Acute3D":
                                                return <Acute3DOption layer={layer} LayerList_2D={LayerList_2D} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "Pipeline":
                                                return <PipelineOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "Model":
                                                return <ModelOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "Projector":
                                                return <ProjectorOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "I3S":
                                                return <I3SOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            case "3DTiles":
                                                return <ThreeDTilesOption layer={layer} deleteLayerList={(layer)=>this.deleteLayerList(layer)} key={layer.layerName}/>;
                                            default:
                                                break;
                                        }
                                    }
                                )
                            }                           
                        </details>
                    </div>                    
                </div>
            </div>            
        );
    }
}
export default LayerOptionSidebar;